module.exports = __webpack_public_path__ + "static/media/transceiver_info_icon.55d06129.png";